import { User } from 'features/users/types/users.types'
import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'libs/form'

type UsePopulateUserProps = {
	data: User | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateUser = ({ data, reset }: UsePopulateUserProps) => {
	useEffect(() => {
		if (data) {
			reset({
				email: data.email,
				name: data.name,
				ssn: data.ssn,
				phone_number: data.phone_number,
				is_active: data.is_active,
				is_staff: data.is_staff,
				is_admin: data.is_admin,
				is_superuser: data.is_superuser,
				address: {
					address: data.address.address,
					postal_code: data.address.postal_code,
					city: data.address.city
				},
				bank_account: data.bank_account,
				bizum_phone: data.bizum_phone,
				payout_method: data.payout_method
			})
		}
	}, [data])
}
